import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Global, css } from '@emotion/react';
import { useCallback } from 'react';
import { useFullscreen } from 'react-science/ui';
import checkModifierKeyActivated from '../../data/utilities/checkModifierKeyActivated';
import Viewer1D from '../1d/Viewer1D';
import FloatMoleculeStructures from '../1d-2d/components/FloatMoleculeStructures';
import Viewer2D from '../2d/Viewer2D';
import KeysListenerTracker from '../EventsTrackers/KeysListenerTracker';
import { useChartData } from '../context/ChartContext';
import Header from '../header/Header';
import DropZone from '../loader/DropZone';
import Panels from '../panels/Panels';
import ToolBar from '../toolbar/ToolBar';
import { SplitPaneWrapper } from './SplitPaneWrapper';
import { StateError } from './StateError';
const viewerContainerStyle = css `
  border: 0.55px #e6e6e6 solid;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  margin-left: -1px;
`;
const containerStyles = css `
  background-color: white;
  width: 100%;
  display: block;
  height: 100%;

  div:focus {
    outline: none !important;
  }

  button {
    cursor: pointer;
  }

  button,
  button:active,
  button:hover,
  button:focus,
  [type='button']:focus {
    outline: none !important;
  }

  button:disabled {
    cursor: default;
  }

  * {
    -webkit-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-select: none;
  }

  .actions-buttons-popover {
    background: transparent;
    padding: 5px;
    box-shadow: none;
  }
`;
export function InnerNMRiumContents(props) {
    const { emptyText, mainDivRef, elementsWrapperRef, rootRef, viewerRef } = props;
    const { displayerMode } = useChartData();
    const { isFullScreen } = useFullscreen();
    const preventContextMenuHandler = useCallback((e) => {
        if (!checkModifierKeyActivated(e)) {
            e.preventDefault();
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(StateError, {}), _jsx(Global, { styles: css `
          .actions-buttons-popover {
            border-radius: 10px;
            padding: 5px;
            background-color: white;
          }
        ` }), _jsx("div", { className: "nmrium-container", ref: rootRef, css: containerStyles, onContextMenu: preventContextMenuHandler, style: { height: '100%', width: '100%' }, children: _jsx(DropZone, { children: _jsxs("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: 'white',
                            width: '100%',
                        }, children: [_jsx(Header, {}), _jsxs("div", { style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    height: '100%',
                                }, children: [_jsx(ToolBar, {}), _jsxs(SplitPaneWrapper, { children: [_jsxs("div", { css: viewerContainerStyle, children: [_jsx(KeysListenerTracker, { mainDivRef: mainDivRef }), _jsxs("div", { id: "nmrium-viewer", "data-testid": "viewer", ref: viewerRef, style: {
                                                            width: '100%',
                                                            height: '100%',
                                                            position: 'relative',
                                                        }, children: [_jsx(FloatMoleculeStructures, {}), displayerMode === '1D' ? (_jsx(Viewer1D, { emptyText: emptyText })) : (_jsx(Viewer2D, { emptyText: emptyText }))] })] }), _jsx(Panels, {})] }), _jsx("div", { ref: elementsWrapperRef, id: "main-wrapper", style: {
                                            position: 'absolute',
                                            pointerEvents: 'none',
                                            zIndex: 10,
                                            left: 0,
                                            right: 0,
                                            top: 0,
                                            bottom: 0,
                                        } }, String(isFullScreen))] })] }) }) })] }));
}
